<div class="toast" [ngClass]="{'open': showToast}">
    <h2>Vous n'êtes plus connecté à Internet</h2>
    <p>
        L'application est maintenant en consultation uniquement. 
        Les modifications seront disponibles dès votre reconnexion.
    </p>
</div>